import { IS_IOS } from '@repo/common-utils';
import { useWorkingPlatform } from '@repo/platform';
import { useDialog } from '@repo/ui';
import { useCallback, useEffect } from 'react';

/**
 * 통합 앱 버전이 5.0 미만인 경우 강제 업데이트를 걸기 위한 훅
 * @description: Todo: 2027년 상반기까지만 코드 유지
 */
export const useForceAppUpdate = () => {
  const { workingPlatform } = useWorkingPlatform();
  const { showDialog } = useDialog();

  const showForceUpdateDialog = useCallback(() => {
    if (IS_IOS) {
      showDialog({
        id: 'force-app-update',
        title: '최신 업데이트가 필요해요',
        description: '더 나은 서비스를 제공해드리기 위해\n앱을 개선해 최신 버전으로 준비했어요.',
        buttons: {
          primary: {
            text: '지금 업데이트',
            isPreventAutoClose: true,
            onClick: () => {
              window.location.href = 'https://apps.apple.com/kr/app/%EB%B9%84%EC%A6%88%EB%84%B5/id1186216942';
            }
          }
        }
      });
    } else {
      showDialog({
        id: 'force-app-update',
        title: '최신 업데이트가 필요해요',
        description:
          '더 나은 서비스를 제공해드리기 위해\n앱을 개선해 최신 버전으로 준비했어요.\n\n구글 플레이스토어에서\n비즈넵앱을 업데이트 하고 이용해주세요.',
        buttons: {
          primary: {
            text: '업데이트 후 이용할게요',
            disabled: true
          }
        }
      });
    }
  }, [showDialog]);

  useEffect(() => {
    if (workingPlatform !== 'app-deprecated') return;

    showForceUpdateDialog();
  }, [showForceUpdateDialog, workingPlatform]);
};
